import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeConf1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3, handleClickSel4,
                handleClickSel5, handleClickSelCl, handleClickSelCa, handleClickSel6, handleClickSel7, handleClickSel8,
                handleClickSel9, handleClickSel10}) => {
  const a2501 = autorizacUA.findIndex( autorizac => autorizac === "2501" );
  const a2505 = autorizacUA.findIndex( autorizac => autorizac === "2505" );
  const a2510 = autorizacUA.findIndex( autorizac => autorizac === "2510" );
  // const a2515 = autorizacUA.findIndex( autorizac => autorizac === "2515" );
  const a2520 = autorizacUA.findIndex( autorizac => autorizac === "2520" );
  const a2522 = autorizacUA.findIndex( autorizac => autorizac === "2522" );
  const a2523 = autorizacUA.findIndex( autorizac => autorizac === "2523" );
  const a2525 = autorizacUA.findIndex( autorizac => autorizac === "2525" );
  const a2530 = autorizacUA.findIndex( autorizac => autorizac === "2530" );
  const a2535 = autorizacUA.findIndex( autorizac => autorizac === "2535" );
  const a2540 = autorizacUA.findIndex( autorizac => autorizac === "2540" );
  // const a2550 = autorizacUA.findIndex( autorizac => autorizac === "2550" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        CONFIGURAR
      </button>

      {a2501!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
          <i className="large newspaper violet icon"></i>
          Servicios
        </button>
      }
      {a2505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
          <i className="large calculator violet icon"></i>
          Impuestos
        </button>
      }
      {a2510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
          <i className="large newspaper outline violet icon"></i>
          Tarifas
        </button>
      }
      {/* {a2515!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
        <i className="large magic violet icon"></i>
        Ofertas
        </button>
      } */}

      {(a2520!==-1||a2522!==-1||a2523!==-1) &&
        <Divider inverted />
      }

      {a2520!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel5}>
          <i className="large configure violet icon"></i>
          Tipo de O de S
        </button>
      }
      {a2522!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelCl}>
          <i className="large configure violet icon"></i>
          Clasificación Tipos OS
        </button>
      }
      {a2523!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelCa}>
          <i className="large configure violet icon"></i>
          Categorías Tipos OS
        </button>
      }

      {a2525!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel6}>
            <i className="large hdd outline violet icon"></i>
            Equipos
          </button>
        </div>
      }

      <Divider inverted />

      {a2530!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel7}>
          <i className="large address book violet icon"></i>
          Tipo de recursos
        </button>
      }
      {a2535!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel8}>
          <i className="large address book outline violet icon"></i>
          Recursos
        </button>
      }

      {a2540!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel9}>
            <i className="large table violet icon"></i>
            Parametros
          </button>
        </div>
      }

      {/* {a2550!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel10}>
            <i className="large table violet icon"></i>
            Bases de Datos
          </button>
        </div>
      } */}

    </div>
  )
};

export default HomeConf1
